/**
 * Cache timing constants for React Query
 */

export const CACHE_TIME = {
  /** Stale time for reports data (30 seconds) */
  STALE_TIME_MS: 30 * 1000,
  /** Polling interval for status checks (5 seconds) */
  POLL_INTERVAL_MS: 5000,
  /**
   * How long report status polling runs before giving up, measured from when
   * polling starts. Longer than the processor's 15-minute Lambda timeout, so a
   * run that is still alive always finishes inside the window; past it the
   * DLQ consumer has marked the report failed or something else is wrong, and
   * My Reports is the better place to look.
   */
  STATUS_POLL_DEADLINE_MS: 20 * 60 * 1000,
  /**
   * Status poll interval after a 429 that carried no Retry-After. Polling a
   * throttled gateway every 5 seconds adds to the burst that throttled it.
   */
  STATUS_POLL_THROTTLED_INTERVAL_MS: 30 * 1000,
  /**
   * Max age of cached report data before a download click refetches to mint
   * fresh presigned URLs. Kept well under the backend's 1h presigned-URL TTL
   * (see backend/handlers/api.py DOWNLOAD_URL_EXPIRY_SECONDS) so any URL that
   * passes the freshness check is guaranteed still valid.
   */
  URL_REFRESH_THRESHOLD_MS: 5 * 60 * 1000,
  /**
   * How long the account balance keeps refetching after a checkout completes,
   * at POLL_INTERVAL_MS apart: about twelve requests.
   *
   * Unlike report polling this has no terminal state to stop on: a balance is
   * always a valid answer, so an unbounded poll on a page someone leaves open
   * would run until the tab closes. A minute is comfortably longer than the
   * webhook round trip, which lands in seconds. A time window rather than an
   * attempt count, because refetchInterval is evaluated more often than it
   * fetches (see useAccount).
   */
  BALANCE_POLL_WINDOW_MS: 60 * 1000,
} as const;
